export const GET_QUOTE_FUNNELS_PRICES = "GET_QUOTE_FUNNELS_PRICES"
export const GET_QUOTE_FUNNELS_PRICES_SUCCESS = "GET_QUOTE_FUNNELS_PRICES_SUCCESS"
export const GET_QUOTE_FUNNELS_PRICES_ERROR = "GET_QUOTE_FUNNELS_PRICES_ERROR"
